<template>
  <section v-bind:id="id" class="section">
    <h2>
      <i class="material-icons left">{{ iconName }}</i>
      {{ title }}
    </h2>

    <BaseProgressBar v-if="loading" v-bind="progressBar"
      >Carregando perfis...</BaseProgressBar
    >
    <p v-else-if="!hasPerfis" class="flow-text center-align">
      Ainda não há perfis cadastrados.
    </p>
    <div v-else>
      <BaseEditableCollection
        class="perfil-collection"
        v-bind="perfilCollection"
      />
      <BasePagination
        class="center"
        v-bind="pagination"
        v-on:change="onPageChange"
      />
    </div>

    <div v-if="!loading" class="buttons-row">
      <BaseButton v-bind="buttonAdd" v-on:click="openPerfilModal" />
    </div>

    <PerfilModal v-bind="perfilModal" v-on:save="getPagePerfis(0)" />

    <PerfilDeletionConfirmModal
      v-bind="perfilDeletionConfirmModal"
      v-on:confirm="deletePerfil"
    />
  </section>
</template>

<script>
import { API_URL } from "../../constants";
import BasePerfil from "./BasePerfil.vue";
import PerfilDeletionConfirmModal from "./PerfilDeletionConfirmModal.vue";
import PerfilModal from "./PerfilModal.vue";

const PERFIS_SEARCH_PAGINATION_SIZE = 10;

export default {
  name: "Perfis",
  components: {
    PerfilDeletionConfirmModal,
    PerfilModal
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true
    },

    title: String,
    iconName: String
  },
  data() {
    return {
      loading: false,
      pageSize: 10,
      perfilModal: {
        id: "sispessoal-controleacesso-perfis-modal",
        value: null
      },
      perfilDeletionConfirmModal: {
        id: "sispessoal-controleacesso-perfis-deletion-confirmmodal",
        value: null
      },
      perfilCollection: {
        component: BasePerfil,
        items: [],
        itemOperations: [
          {
            iconName: "edit",
            color: "green",
            onClick: this.openPerfilModal,
            title: "Editar perfil"
          },
          {
            iconName: "delete",
            color: "red",
            onClick: this.openPerfilDeletionConfirmModal,
            title: "Excluir perfil"
          }
        ]
      },
      buttonAdd: {
        iconName: "verified_user",
        title: "Criar perfil",
        content: "Novo"
      },
      pagination: {
        value: 1,
        numPages: 0
      },
      progressBar: {
        useContainer: false
      }
    };
  },
  computed: {
    hasPerfis() {
      return (this.perfilCollection.items || []).length !== 0;
    }
  },
  created() {
    this.getPagePerfis(0);
  },
  methods: {
    openPerfilModal(item, index) {
      const perfis = this.perfilCollection.items || [];

      // Edição de perfil
      if (index >= 0 && index < perfis.length) {
        this.perfilModal.value = perfis[index].value.id;
      }
      // Criação de perfil
      else {
        this.perfilModal.value = null;
      }

      this.$nextTick().then(() =>
        this.$utils.Components.openModal(this.perfilModal.id)
      );
    },
    openPerfilDeletionConfirmModal(item, index) {
      const perfis = this.perfilCollection.items || [];

      if (index >= 0 && index < perfis.length) {
        this.perfilDeletionConfirmModal.value = perfis[index].value;
        this.$nextTick().then(() =>
          this.$utils.Components.openModal(this.perfilDeletionConfirmModal.id)
        );
      }
    },
    onPageChange(event) {
      this.getPagePerfis(event - 1);
    },
    getPagePerfis(page) {
      this.loading = true;

      this.perfilCollection.items = [];

      this.$http
        .get(
          `${API_URL}/acesso/perfil?pagina=${page}&tamanhoPagina=${PERFIS_SEARCH_PAGINATION_SIZE}`
        )
        .then(response => {
          const items = response.data.elementos;
          const total = response.data.tamanhoTotal;

          this.pagination.value = page + 1;
          this.pagination.numPages = Math.ceil(
            total / PERFIS_SEARCH_PAGINATION_SIZE
          );

          this.perfilCollection.items = items
            .map(item => ({ value: { ...item } }))
            .sort((a, b) => (a.value.nome < b.value.nome ? -1 : 1));
        })
        .catch(error =>
          this.$notification.pushError(
            `Houve um erro ao obter a lista de perfis: ${error.message}`
          )
        )
        .finally(() => (this.loading = false));
    },
    deletePerfil(event) {
      if (!event) {
        this.perfilDeletionConfirmModal.value = null;
        return;
      }

      // TODO: verificar se o perfil está associado a algum usuário

      const perfilId = this.perfilDeletionConfirmModal.value.id;

      this.$http
        .delete(`${API_URL}/acesso/perfil/${perfilId}`)
        .then(() => {
          this.$notification.pushSuccess("Perfil excluído com sucesso");

          this.getPagePerfis(0);
        })
        .catch(error =>
          this.$notification.pushError(
            `Houve um erro ao excluir perfil: ${error.message}`
          )
        );
    }
  }
};
</script>

<style scoped>
.buttons-row {
  justify-content: right;
}
</style>
